import { Table, Button, Result, Modal, Divider, Form, Input, Select, Row, Col, Switch } from 'antd';
import 'react-tiny-fab/dist/styles.css';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { TableWrapper } from '../../Commons';
import { useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { startCase } from 'lodash';
import './style.scss';
import { copyWorkFlow, deleteWorkFlowByAdmin, fetchWorkflowsByAdmin, toggleStatus} from '../../Http/workflow';
import { fetchAllUsersByAdmin } from '../../Http/users';
import { AiOutlineCaretLeft as CaretLeftOutlined, AiOutlineCaretRight as CaretRightOutlined, AiFillDelete as DeleteFilled, AiFillWarning as WarningFilled } from "react-icons/ai";
import { addWorkflow } from '../../redux/slices/workflow/workflowList';


const { Option } = Select;


      
const AllWorkFlows = () => {

	const [data, setData] = useState([]);
	const [users, setUsers] = useState([]);
	const [refresh, setRefresh] = useState(true);
	const dispatch = useDispatch();
	const [workflowId, setWorflowId] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);
	const [page, setPage] = useState(0);
	const [limit, setLimit] = useState(undefined);
	const history = useHistory();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [form] = Form.useForm();

	useEffect(() => {
        getAllWorkFlows();
	}, [page, refresh]);

	useEffect(()=>{
		getAllUsersByAdmin();
	},[])

    const getAllWorkFlows = async(params={})=>{
		setLoading(true);
		params.page = page;
        const res = await fetchWorkflowsByAdmin({...params})
		//console.log({workflowRes: res})
        if(res?.data?.code === 0){
			setLoading(false);
            setData(res.data.data?.workflows);
			if (!limit) setLimit(res.data.data?.limit);
            setError(false);
        } else {
            setError(true);
        }
    }

	//console.log({dataRes:data})

	const getAllUsersByAdmin = async()=>{
		const res = await fetchAllUsersByAdmin();
		if(res.code === 0){
            setUsers(res?.data?.map(user=>{return {label: user.email, value: user.id}}));
            setError(false);
        } else {
            setError(true);
        }
	}

	const extractCols = () => {
		if (!data || data.length === 0) return [];

		let jsonKeys = Object.keys(data[0]);
		let columns = [];

		jsonKeys.forEach((v) => {
			if(v === 'sourceData' || v === 'responseData' || v === 'status') {
				// escape
			} else {
				let cell = {
					title: startCase(v) ,
					dataIndex: v,
					key: v,
					align: 'center',
					ellipsis: true,
				};
				columns.push(cell);
			}
		});
		const action = {
			title: 'Action',
			key: 'operation',
			align:'center',
			width: 300,
			render: (record) => {
				return(
					<div style={{display:"flex",justifyContent:"space-around"}}>
						<Button
						onClick={() => confirmDelete(record?.workflowId)}
						type='link'
						style={{ color: 'red' }}
						icon={
							<DeleteFilled style={{ fontSize: '1.5rem' }} />
							}></Button>
						<Link to={`/system/workflows/${record?.workflowId}/logs`}>
							View Logs
						</Link>
						<Button style={{background: '#252B6A', borderColor: '#252B6A', color:'#ffffff'}} type="primary" onClick={()=>copy(record)}>Copy</Button>
					</div>
				)
			},
		};
		const activateStatus = {
			title: 'Active',
			key: 'status',
			width: 50,
			align:'center',
			render: (record) => {
				return(
					<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
						<Switch
							id={record.workflowId}
							checked={record.status === '02'}
							onChange={() => handleToggle(record.workflowId)}
						/>
					</div>
				)
			},
		};
		columns.push(activateStatus)
		columns.push(action);

		return columns;
	};

	const extractRows = () => {
		if (!data || data.length === 0) return [];
		let rows = [];
		data.forEach((v, k) => {
			rows.push({ ...v, key: k });
		});
		return rows;
	};
	const CustomPagination = () => {
		let style = {
			rowStyle: { margin: '.5rem' },
			colStyle: { marginRight: '.5rem' },
		};
		return (
			<Row justify='end' style={style.rowStyle}>
				<Col style={style.colStyle}>
					<Button disabled={page < 1} onClick={() => setPage(page - 1)}>
						<CaretLeftOutlined />
					</Button>
				</Col>
				<Col>
					<Button
						disabled={data.length < limit}
						onClick={() => setPage(page + 1)}>
						<CaretRightOutlined />
					</Button>
				</Col>
			</Row>
		);
	};

	const copy = (record)=>{
		setWorflowId(record?.workflowId)
		setIsModalOpen(true);
		
	}
	const cloneWorkflow = (value)=>{
		//console.log({values:value})
		const newValue = {
			userId: value?.id,
			workflowId
		}
		copyWorkFlow(newValue)
		.then(res=>{
			if(res?.code === 0){
				toast.success('Workflow Coppied Successfully.');
				setIsModalOpen(false);
			}
			if(res?.code === 1){
				toast.error(res.message);
				setIsModalOpen(false);				
				//console.log({copy_res:res})
			}
		})
		.catch(err=>{
			//console.log(err)
		})
	}

	const clearSearchValues = ()=>{
		form.resetFields()
		setRefresh(!refresh);

	}
	const filterWorkflows = (value) => {
		const params = {};
		if(value?.workflowName) params.workflowName = value.workflowName;
		if(value?.workflowId) params.workflowId = value.workflowId;
		if(value?.status) params.status = value.status;
		getAllWorkFlows({...params});
	}
	const handleToggle = async (id) => {
		const workflowRes = await toggleStatus(id);
		if(workflowRes.code === 0){
			dispatch(addWorkflow(workflowRes.data));
			setRefresh(!refresh);
		}
		
	};
	const confirmDelete = (id) => {
		Modal.confirm({
			title: 'Delete Workflow',
			content: <div>Are you sure you want to delete this workflow?</div>,
			icon: <WarningFilled />,
			onOk: async () => {
				const res = await deleteWorkFlowByAdmin(id);
				if(res.code === 0){
					setRefresh(!refresh)
				}
			},
		});
	};


	return (
		
		<>
			<ToastContainer />
			<div style={{justifyContent: 'start', display: 'flex', width: '100%'}}>
				<Form
					form={form}
					name="advanced_search"
					className="ant-advanced-search-form"
					onFinish={filterWorkflows}
					style={{width: '100%'}}
				>
					<Row gutter={24}>
						<Col span={4} style={{paddingLeft: '20px'}}>Workflow Id : </Col>
						<Col span={12}>Workflow Name : </Col>
						<Col span={4}>Status : </Col>
					</Row>
					<Row gutter={24}>
						<Col span={4} style={{paddingLeft: '20px'}}>
							<Form.Item name="workflowId">
								<Input placeholder='Workflow Id' />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item name="workflowName" >
								<Input placeholder='Workflow Name' />
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item name="status" >
								<Select
									placeholder="Select status"
									allowClear
								>
									<Option value="02">Active</Option>
									<Option value="01">Inactive</Option>
								</Select>
							</Form.Item>
						</Col>
						<Col span={4} style={{textAlign: 'right'}}>
							<Button type="primary" htmlType="submit">
								Search
							</Button>
							<Button style={{margin: '0 8px'}} onClick={() => clearSearchValues()}>
								Clear
							</Button>
						</Col>
					</Row>
				</Form>
			</div>
			<TableWrapper style={{marginBottom:"70px", padding:0}} className='wrapper'>
				{!error ? (
					<>
						<Modal className="log-modal" footer={false} title={<Divider orientation="center">Copy the workflow for the user</Divider>} width={720} open={isModalOpen} onOk={()=>setIsModalOpen(false)} onCancel={()=>setIsModalOpen(false)}>
							<Form
								form={form}
								name="advanced_search"
								className="ant-advanced-search-form"
								onFinish={cloneWorkflow}
								style={{width: '100%'}}
							>
								<Form.Item name="id" >
									<Select
										allowClear
										showSearch
										optionFilterProp="children"
    									// onChange={onChange}
										// onSearch={onSearch}
										filterOption={(input, option) =>
											(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
										}
										options={users}
										>
									</Select>
								</Form.Item>
								<Button type="primary" htmlType="submit">
									Confirm
								</Button>
								
								
							</Form>
								
						</Modal>
						<Table 
							loading={loading}
							scroll={{ x: 'max-content' }}
							pagination={false}
							dataSource={extractRows()}
							columns={extractCols()}
						>
						</Table>
						<CustomPagination />
					</>
				) : (
					<Result
						status='404'
						title='404'
						subTitle='Sorry, the page you visited does not exist.'
						extra={
							<Button
								type='primary'
								onClick={() => history.replace('/system/workflows')}>
								Back Home
							</Button>
						}
					/>
				)}
			</TableWrapper>
			{/* <Fab
			 event='click'
			 icon={<ArrowLeftOutlined/>}
			 mainButtonStyles={{background: '#252B6A'}}
			 onClick={()=>history.replace("/system/users")}
			>
			</Fab> */}

			
		</>
	);
};

export default AllWorkFlows;
